@if (isMobile() && isReels()) {
  <app-home-reels></app-home-reels>
} @else {
  <app-home [showFecha]="showFecha"></app-home>
}
